import React, { FC } from 'react';
import { OrdersListingType } from '../../../models/orders-listing-type';
import OrdersListingTable from '../../molecules/orders-listing-table/orders-listing-table';

const OrdersListing: FC<OrdersListingType> = (props: OrdersListingType) => (
  <div className="py-component-spacing-mobile lg:py-component-spacing">
    <OrdersListingTable {...props} />
  </div>
);

export default OrdersListing;
